import { cn } from "@/lib/utils";

export function TherapiesLoadingSkeleton() {
  return (
    <>
      {/* Desktop skeleton */}
      <div className="hidden lg:block">
        <div className="overflow-hidden rounded-2xl border border-border/60 bg-card shadow-sm">
          <div className="bg-muted/40 px-4 py-2.5">
            <div className="flex gap-12">
              {Array.from({ length: 6 }).map((_, i) => (
                <div key={i} className="h-3 w-14 animate-pulse rounded bg-muted" />
              ))}
            </div>
          </div>
          {Array.from({ length: 8 }).map((_, i) => (
            <div
              key={i}
              className={cn(
                "flex items-center gap-8 px-4 py-3",
                i !== 7 && "border-b border-border/40"
              )}
            >
              <div className="space-y-1">
                <div className="h-3.5 w-20 animate-pulse rounded bg-muted" />
                <div className="h-2.5 w-16 animate-pulse rounded bg-muted/50" />
              </div>
              <div className="flex items-center gap-2">
                <div className="size-6 animate-pulse rounded-full bg-muted" />
                <div className="h-3.5 w-24 animate-pulse rounded bg-muted" />
              </div>
              <div className="flex items-center gap-2">
                <div className="size-6 animate-pulse rounded-full bg-muted" />
                <div className="h-3.5 w-28 animate-pulse rounded bg-muted" />
              </div>
              <div className="h-3.5 w-32 animate-pulse rounded bg-muted/50" />
              <div className="h-3.5 w-16 animate-pulse rounded bg-muted" />
              <div className="ml-auto flex gap-1.5">
                <div className="h-5 w-14 animate-pulse rounded-md bg-muted/50" />
                <div className="h-5 w-14 animate-pulse rounded-md bg-muted/50" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Mobile/Tablet skeleton */}
      <div className="grid gap-3 sm:grid-cols-2 lg:hidden">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="rounded-2xl border border-border/60 bg-card p-4 shadow-sm">
            <div className="flex items-start justify-between">
              <div className="flex items-center gap-2.5">
                <div className="h-11 w-11 animate-pulse rounded-xl bg-muted" />
                <div className="space-y-1.5">
                  <div className="h-3.5 w-12 animate-pulse rounded bg-muted" />
                  <div className="h-3 w-10 animate-pulse rounded bg-muted/60" />
                </div>
              </div>
              <div className="h-4 w-16 animate-pulse rounded-md bg-muted" />
            </div>
            <div className="mt-3 space-y-2">
              <div className="flex items-center gap-2">
                <div className="size-7 animate-pulse rounded-full bg-muted" />
                <div className="space-y-1">
                  <div className="h-3.5 w-28 animate-pulse rounded bg-muted" />
                  <div className="h-3 w-36 animate-pulse rounded bg-muted/50" />
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="size-7 animate-pulse rounded-full bg-muted" />
                <div className="space-y-1">
                  <div className="h-3.5 w-24 animate-pulse rounded bg-muted" />
                  <div className="h-3 w-32 animate-pulse rounded bg-muted/50" />
                </div>
              </div>
            </div>
            <div className="mt-3 grid grid-cols-2 gap-2 border-t border-border/40 pt-3">
              {Array.from({ length: 4 }).map((_, j) => (
                <div key={j} className="space-y-1">
                  <div className="h-2.5 w-16 animate-pulse rounded bg-muted/50" />
                  <div className="h-3.5 w-12 animate-pulse rounded bg-muted" />
                </div>
              ))}
            </div>
            <div className="mt-3 flex items-center justify-between border-t border-border/40 pt-3">
              <div className="h-4 w-24 animate-pulse rounded bg-muted/60" />
              <div className="h-5 w-20 animate-pulse rounded-full bg-muted/50" />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
